import { HttpError, useStores } from '@littlebird/sdk';
import { toast } from 'sonner';

import { ConfirmDialog } from '@/components/modals/ConfirmationModal';
import { ModalsManager } from '@/components/modals/modalsManager';
import { RESTART_WAITING_RUN_COPY } from '@/features/routines/components/waiting-run-copy';

/**
 * Asks first, then saves the form so the new instructions are on the server,
 * then restarts. `saveRoutine` resolves `false` when the save did not happen,
 * and shows its own error.
 */
export const useRestartWaitingRun = ({
  saveRoutine,
  wrapModal,
}: {
  saveRoutine: () => Promise<boolean>;
  wrapModal: <T>(show: () => Promise<T>) => Promise<T>;
}) => {
  const { routines } = useStores();

  return async (
    routineId: number,
    waitingDevices: readonly { platform: string }[]
  ) => {
    const confirmed = await wrapModal(() =>
      ModalsManager.showResolvable(ConfirmDialog, {
        title: RESTART_WAITING_RUN_COPY.confirmTitle,
        description: RESTART_WAITING_RUN_COPY.confirmBody(waitingDevices),
        confirmText: RESTART_WAITING_RUN_COPY.confirmButton,
        cancelText: RESTART_WAITING_RUN_COPY.cancelButton,
        confirmVariant: 'default',
      })
    );
    if (!confirmed || !(await saveRoutine())) return;
    await routines
      .restartWaitingRun(routineId)
      .catch((error: unknown) =>
        toast.error(
          error instanceof HttpError && error.userErrorMessage
            ? error.userErrorMessage
            : RESTART_WAITING_RUN_COPY.failure
        )
      );
  };
};
